/**
 * One toaster id for the whole task pane, so any panel can raise a notification
 * without each of them creating its own toast host.
 */
export const TOASTER_ID = 'templatean-toaster'
